import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useStyles } from "./CircularIndeterminate.styled";

const CircularIndeterminate = ({ size }) => {
  const classes = useStyles();
  let sizeCircle = { width: "40px", height: "40px" };
  if (size) {
    sizeCircle = { width: size + "px", height: size + "px" };
  }

  return (
    <div className={classes.root}>
      <CircularProgress style={sizeCircle} />
    </div>
  );
};
export default CircularIndeterminate;
